import type { RouteLocationRaw } from 'vue-router';

import { ROUTE_NAMES } from '@/router/routeNames';

const PENDING_REDIRECT_KEY = 'mx.pendingRedirect';

export function resolveSafeRedirect (redirect: unknown): string | null {
  if (
    typeof redirect !== 'string' ||
    !redirect.startsWith('/') ||
    redirect.startsWith('//')
  ) {
    return null;
  }

  return redirect;
}

export function rememberPendingRedirect (redirect: unknown): void {
  if (redirect === undefined || redirect === null || redirect === '') {
    return;
  }

  const safeRedirect = resolveSafeRedirect(redirect);

  if (safeRedirect === null) {
    sessionStorage.removeItem(PENDING_REDIRECT_KEY);
    return;
  }

  sessionStorage.setItem(PENDING_REDIRECT_KEY, safeRedirect);
}

export function takePendingRedirect (): string | null {
  const stored = sessionStorage.getItem(PENDING_REDIRECT_KEY);
  sessionStorage.removeItem(PENDING_REDIRECT_KEY);

  return resolveSafeRedirect(stored);
}

export function startupLocation (redirectPath: string): RouteLocationRaw {
  return {
    name: ROUTE_NAMES.STARTUP,
    query: { redirect: redirectPath },
  };
}

export function postAuthDestination (redirect: unknown): RouteLocationRaw {
  return resolveSafeRedirect(redirect) ?? { name: ROUTE_NAMES.HOME };
}
